import type { TIssue } from "@/types/issue";

/**
 * Collection / render identity for a (possibly-occurrence) work-item row (NG-843).
 *
 * A recurring event's virtual occurrences all share the series master's
 * `id` (the backend returns one flat row per occurrence in the window with the
 * master `id` kept for navigation — see NG-840). Keying a store map or an id-list
 * by `id` therefore collapses every occurrence of a series to a single row. This
 * composite key keeps them distinct while leaving every non-occurrence row keyed by
 * its own `id` exactly as before — for anything that is not an occurrence,
 * `occurrenceKey(i) === i.id`, so the store's identity is unchanged off the
 * recurring-events path.
 *
 * `id` stays the value used for navigation (opening the series master); this key is
 * only the *collection* identity.
 */
export const occurrenceKey = (
  i: Pick<TIssue, "id" | "is_occurrence" | "series_id" | "recurrence_id">,
): string =>
  i.is_occurrence && i.recurrence_id ? `${i.series_id ?? ""}:${i.recurrence_id}` : i.id;
